import React, { useEffect, useRef, useState } from "react";
import "./upcomingEvents.scss";
import CommonCta from "../CommonCta/CommonCta";
import { calendar, clock, leftArrowWhite, rightArrowWhite } from "../../source";
import { useWindowSize } from "react-use";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

const UpcomingEvents = ({
  leftHeading,
  lefDesc,
  ctaText,
  ctaLink,
  eventsData,
}) => {
  const { width } = useWindowSize();
  const [isHeight, setIsHeight] = useState(null);
  const getDivHeightRef = useRef();

  useEffect(() => {
    if (width <= 991) {
      setIsHeight(getDivHeightRef.current.clientHeight);
      // console.log("heigth", getDivHeightRef.current.clientHeight);
    }
  }, [isHeight, width]);

  return (
    <>
      <div className="row upcoming_row">
        <div className="col-lg-5 upcoming_col">
          <div className="upcoming_box">
            {/* <h2 className="section_heading100">{leftHeading}</h2> */}
            <h2
              className="section_heading100"
              dangerouslySetInnerHTML={{ __html: leftHeading }}
            ></h2>
            <p
              className="section_desc22"
              dangerouslySetInnerHTML={{ __html: lefDesc }}
            ></p>
            {width > 991 && (
              <CommonCta linkCta={true} text={ctaText} link={ctaLink} />
            )}
          </div>
        </div>
        <div className="col-lg-7 upcoming_col">
          {width > 991 ? (
            <div className="upcoming_box">
              {eventsData.map((item, i) => (
                <div className="row event_row" key={i}>
                  <div className="col-lg-5 event_col">
                    <div className="event_img_wrapper">
                      <img
                        src={item.img}
                        alt={item.alt}
                        className="event_img"
                      />
                    </div>
                  </div>
                  <div className="col-lg-7 event_col">
                    <div className="event_content_wrapper">
                      {/* <span className="status">{item.status}</span> */}
                      <h4 className="section_heading28">{item.title}</h4>
                      <div className="schedule_wrapper">
                              {/* schedule_content coming soon */}
                        {/* <div className="schedule_content">
                          <img
                            src={calendar}
                            alt="calendar"
                            className="schedule_img"
                          />
                          <p className="data_time">{item.date}</p>
                        </div> */}
                        {/* <div className="schedule_content">
                          <img
                            src={clock}
                            alt="clock"
                            className="schedule_img"
                          />
                          <p className="data_time">{item.time}</p>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="upcoming_box" data-aos="fade-up">
              <Swiper
                className="events_slider"
                modules={[Autoplay, Navigation]}
                slidesPerView={2}
                spaceBetween={20}
                loop={true}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
                navigation={{
                  nextEl: ".right_arrow",
                  prevEl: ".left_arrow",
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                  },
                  768: {
                    slidesPerView: 2,
                  },
                }}
              >
                {eventsData.map((item, i) => (
                  <SwiperSlide key={`events-${i}`}>
                    <div className="event_row">
                      <div className="event_col">
                        <div
                          className="event_img_wrapper"
                          ref={getDivHeightRef}
                        >
                          <img
                            width={396}
                            height={253}
                            src={item.img}
                            alt={item.alt}
                            className="event_img"
                          />
                        </div>
                      </div>
                      <div className="event_col">
                        <div className="event_content_wrapper">
                          {/* <span className="status">{item.status}</span> */}
                          <h4 className="section_heading28">{item.title}</h4>
                          <div className="schedule_wrapper">
                            {/* schedule_content coming soon */}
                            {/* <div className="schedule_content">
                              <img
                                src={calendar}
                                alt="calendar"
                                className="schedule_img"
                              />
                              <p className="data_time">{item.date}</p>
                            </div> */}
                            {/* <div className="schedule_content">
                              <img
                                src={clock}
                                alt="clock"
                                className="schedule_img"
                              />
                              <p className="data_time">{item.time}</p>
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
                <div
                  className="event_arrows"
                  style={{ top: `${isHeight / 2 - 20}px` }}
                >
                  <img
                    src={leftArrowWhite}
                    alt="left arrow"
                    className="left_arrow"
                  />
                  <img
                    src={rightArrowWhite}
                    alt="right arrow"
                    className="right_arrow"
                  />
                </div>
              </Swiper>
              {width <= 991 && (
                <CommonCta linkCta={true} text={ctaText} link={ctaLink} />
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default UpcomingEvents;
